import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridFooter, GRID_CHECKBOX_SELECTION_COL_DEF, GridColumnMenu, useGridApiRef } from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import SendMassTxt from '../../Modals/SendMassTxt';
import SendMassEmail from '../../Modals/SendMassEmail';
import { launchPhoneBurner } from '../../../common/utils';


const toolbar = ( { selectedRows, handleModal, hasTxting, canExport } ) => {
    return (
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                <Dropdown.Item onClick={ () => handleModal( 'email-mass' ) }>Send Mass Email</Dropdown.Item>
                                                {
                                                    hasTxting ? (
                                                        <Dropdown.Item onClick={ () => handleModal( 'sms-mass' ) }>Send Mass Txt</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Dropdown.Divider />
                                                {/* {
                                                    hasPhoneBurner ? (
                                                        <Dropdown.Item onClick={ () => handleModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                } */}
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const Birthdays = ( { aid, meta, user, viewing, canExport, stack, contacts, loans, lists, start, end } ) => {
    const [ colsSource, setColsSource ] = useState( [
        { field: 'name', headerName: 'Name', width: 150, renderCell: ( params ) => <Link to={`/contact/${params.row.id}`}>{params.value}</Link>  },
        { field: 'email', headerName: 'Email', width: 200, renderCell: ( { value } ) => {
            return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
        },
        valueGetter: ( { value } ) => {
            return ( value ) ? value : null;
        } },
        { field: 'phone', headerName: 'Phone', width: 125 },
        { field: 'mobile', headerName: 'Mobile Phone', width: 125 },
        { field: 'bday', headerName: 'Birthday', type: 'date', valueFormatter: ( { value } ) => value.toLocaleDateString( 'en-US', { month: 'short', day: 'numeric' } ) },
        { field: 'role', headerName: 'Contact Role', width: 150 },
        { field: 'closed', headerName: 'Closed Loan', width: 100, type: 'boolean' },
        { field: 'rank', headerName: 'Target Level', width: 200, valueGetter: ( { row } ) => {
            const c = contacts[row.id];
            let rank = c?.rank;

            if ( c && !rank && c.partnerRank ) {
                rank = c.partnerRank
            }
            return rank
        } },
        { field: 'referredById', headerName: 'Referred By', width: 200, valueGetter: ( { row } ) => {
            return formatName( row.referredById );
        }, renderCell: ( { row } ) => {
            let l;
            if ( row && row.referredById ) {
                const c = contacts[row.referredById];
                if ( c ) {
                    l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                }
            }
            return l;
        }, valueFormatter: ( { value } ) => {
            return ( value ) ? value : '';
        } },
        { field: 'homeAddress', headerName: 'Home Address', width: 150 },
        { field: 'homeCity', headerName: 'Home City', width: 150 },
        { field: 'homeState', headerName: 'Home State', width: 150 },
        { field: 'homeZip', headerName: 'Home Zip', width: 150 },
        { field: 'homeCounty', headerName: 'Home County', width: 150 },
        { field: 'mailingAddress', headerName: 'Mailing Address', width: 150 },
        { field: 'mailingCity', headerName: 'Mailing City', width: 150 },
        { field: 'mailingState', headerName: 'Mailing State', width: 150 },
        { field: 'mailingZip', headerName: 'Mailing Zip', width: 150 },
        { field: 'mailingCounty', headerName: 'Mailing County', width: 150 },
        { field: 'workAddress', headerName: 'Work Address', width: 150 },
        { field: 'workCity', headerName: 'Work City', width: 150 },
        { field: 'workState', headerName: 'Work State', width: 150 },
        { field: 'workZip', headerName: 'Work Zip', width: 150 },
        { field: 'groups', headerName: 'Lists', width: 400 }
    ] );
    const [ bdays, setBdays ] = useState( [] );
    const [ loading, setLoading ] = useState( true );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const gridRef = useGridApiRef();
    
    const formatName = ( cid ) => {
        const r = contacts[cid];
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };
    
    const handleModal = async ( t ) => {
        let shouldOpen = true;

        let list = [];
        let cids = new Set();
        selectedRows.forEach( cid => {
            const c = contacts[cid];
            if ( c ) {
                cids.add( cid );
                list.push( c );
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={Array.from( cids )} objType='contact' /> );
                break;

            // case 'sms':
            //     setModal( <SendTxt close={closeModal} /> );
            //     break;

            // case 'list':
            //     setModal( <AddToGroup close={closeModal} contacts={contacts} /> );
            //     break;
    
            // case 'event':
            //     setModal( <AddEvent close={closeModal} contacts={contacts} /> );
            //     break;

            // case 'phoneburner':
            //     await launchPhoneBurner( aid, uid, cids, list, stack.dialer );
            //     shouldOpen = false;
            //     break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    useEffect( () => {
        let list = [];
        
        console.log( 'inside useEffect for bdays' );
        if ( contacts ) {
            const sharePartners = ( user && user.org && user.org.sharePartners === true ) ? true : false;
            const today = new Date();
            const sd = new Date( start + 'T12:00:00.000' );
            const ed = new Date( end + 'T12:00:00.000' );
            sd.setFullYear( today.getFullYear() );
            ed.setFullYear( today.getFullYear() );

            const funded = new Set();
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( !viewing.includes( l.aid ) || ![ 'Closed', 'Funded' ].includes( l.status ) ) {
                    return;
                }
                l.borrowers?.forEach( b => funded.add( b.cid ) );
            } );

            console.log( 'starting to loop contacts' );
            Object.keys( contacts ).forEach( cid => {
                const c = contacts[cid];
                if ( !( ( c.priRole === 'partner' && sharePartners ) || viewing.includes( c.aid ) ) ) {
                    return;
                }

                if ( c.birthday ) {
                    const bd = new Date( c.birthday + 'T12:00:00.000' );
                    bd.setFullYear( today.getFullYear() );

                    if ( bd.getTime() >= sd.getTime() && bd.getTime() <= ed.getTime() ) {
                        const groups = [];
                        Object.keys( lists ).forEach( l => {
                            const yes = lists[l]?.cids?.find( f => f === c.cid );
                            if ( yes ) {
                                groups.push( lists[l].label );
                            }
                        } );

                        list.push( {
                            id: c.cid,
                            name: `${c.firstname} ${c.lastname}`,
                            email: c.email,
                            phone: c.phone,
                            mobile: c.phoneMobile,
                            bday: bd,
                            role: 'Primary',
                            closed: funded.has( c.cid ),
                            referredById: c.referredById,
                            homeAddress: c.homeAddress1,
                            homeCity: c.homeCity,
                            homeState: c.homeState,
                            homeZip: c.homeZip,
                            homeCounty: c.homeCounty,
                            mailingAddress: c.mailingAddress1,
                            mailingCity: c.mailingCity,
                            mailingState: c.mailingState,
                            mailingZip: c.mailingZip,
                            mailingCounty: c.mailingCounty,
                            workAddress: c.workAddress1,
                            workCity: c.workCity,
                            workState: c.workState,
                            workZip: c.workZip,
                            groups: groups.join( ' - ' )
                        } );
                    }
                }

                if ( c.birthdayPartner1 ) {
                    const bd = new Date( c.birthdayPartner1 + 'T12:00:00.000' );
                    bd.setFullYear( today.getFullYear() );

                    const groups = [];
                    Object.keys( lists ).forEach( l => {
                        const yes = lists[l]?.cids?.find( f => f === c.cid );
                        if ( yes ) {
                            groups.push( lists[l].label );
                        }
                    } );
                    if ( bd.getTime() >= sd.getTime() && bd.getTime() <= ed.getTime() ) {
                        list.push( {
                            id: c.cid,
                            name: `${c.firstnamePartner1} ${c.lastnamePartner1}`,
                            email: c.emailPartner1,
                            phone: c.phonePartner1,
                            mobile: c.phoneMobilePartner1,
                            bday: bd,
                            role: `Partner: ${c.firstname} ${c.lastname}`,
                            homeAddress: c.homeAddress1,
                            homeCity: c.homeCity,
                            homeState: c.homeState,
                            homeZip: c.homeZip,
                            mailingAddress: c.mailingAddress1,
                            mailingCity: c.mailingCity,
                            mailingState: c.mailingState,
                            mailingZip: c.mailingZip,
                            workAddress: c.workAddress1,
                            workCity: c.workCity,
                            workState: c.workState,
                            workZip: c.workZip,
                            groups: groups.join( ' - ' )
                        } );
                    }
                }
            } );
        }

        list.sort( ( a, b ) => {
            return a.bday.getTime() - b.bday.getTime();
        } );
        
        setBdays( list );
        setLoading( false );
    }, [ contacts, loans, lists, start, end, viewing, user ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid>
            <Row>
                <Col className='p-2'>
                    <Row>
                        <Col>
                            Birthdays
                        </Col>
                    </Row>
                    <Row>
                        <Col className='overflow-auto' style={ { height: '500px' } }>
                            <DataGridPro
                                apiRef={gridRef}
                                initialState={ { 
                                    pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                } }
                                loading={ loading }
                                rows={ bdays}
                                columns={ colsSource}
                                density='compact'
                                checkboxSelection
                                disableSelectionOnClick
                                hideFooter={ true }
                                slots={ { 
                                    toolbar: toolbar,
                                    columnMenu: customColumnMenu 
                                } }
                                slotProps={ { toolbar: {
                                    selectedRows: selectedRows, 
                                    handleModal: handleModal, 
                                    hasTxting: hasTxting, 
                                    canExport: canExport
                                } } }
                                onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    meta: state.user.meta,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    lists: state.lists.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Birthdays );